import NEGATIVE_DATA from './negative';
import POSITIVE_DATA from './positive';

export default {
    positive: POSITIVE_DATA,
    negative: NEGATIVE_DATA
}